<p-toast></p-toast>
<div class="loading-overlay flex flex-column" *ngIf="loading">
    <span class="loader"></span>
    <span class="text-white text-xl">Enviando Correos...</span>
</div>

<div class="grid">
    <div class="col-12">
        <div class="card p-4">
            <!-- TÍTULO -->
            <div class="flex align-items-center justify-content-between mb-4">
                <div>
                    <h2 class="m-0 text-900">✉️ Enviar Correo</h2>
                    <span class="text-500">Envía correos electrónicos a tus contactos</span>
                </div>
            </div>

            <form *ngIf="formGroup" [formGroup]="formGroup">
                <!-- EMPRESA (solo superadmin) -->
                <div class="grid mb-4 p-3 surface-50 border-round" *ngIf="currentUser.superusuario">
                    <div class="col-12 md:col-2">
                        <label class="block text-500 text-sm mb-1">Empresa ID</label>
                        <div class="p-inputgroup">
                            <input pInputText formControlName="id_empresa" (change)="onEmpresa()" placeholder="ID"/>
                            <button pButton icon="pi pi-search" (click)="onListaEmpresa()"></button>
                        </div>
                    </div>
                    <div class="col-12 md:col-10">
                        <label class="block text-500 text-sm mb-1">Nombre de la Empresa</label>
                        <input pInputText formControlName="nombre_empresa" readonly class="w-full bg-white"/>
                    </div>
                </div>

                <!-- PÁGINA 1: SELECCIÓN DE DESTINATARIOS -->
                <div class="mb-4">
                    <div class="flex align-items-center mb-3">
                        <span class="text-900 font-bold text-xl mr-2">1.</span>
                        <span class="text-900 font-bold text-xl">¿A quién le vas a enviar el correo?</span>
                    </div>
                    
                    <!-- OPCIONES DE ORIGEN -->
                    <div class="grid">
                        <div class="col-12 md:col-6">
                            <div class="border-2 border-round p-4 cursor-pointer transition-colors transition-duration-200"
                                [class.border-blue-500]="formGroup.get('origen').value === 'contactos'"
                                [class.surface-50]="formGroup.get('origen').value === 'contactos'"
                                [class.border-300]="formGroup.get('origen').value !== 'contactos'"
                                (click)="formGroup.get('origen').setValue('contactos'); onOrigenChange()">
                                <div class="flex align-items-center">
                                    <div class="flex align-items-center justify-content-center surface-100 border-circle w-3rem h-3rem mr-3">
                                        <i class="pi pi-users text-xl text-600"></i>
                                    </div>
                                    <div>
                                        <span class="font-bold text-lg">Lista de Contactos</span>
                                        <p class="text-500 m-0 text-sm">Elegir de mi base de datos de contactos</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 md:col-6">
                            <div class="border-2 border-round p-4 cursor-pointer transition-colors transition-duration-200"
                                [class.border-blue-500]="formGroup.get('origen').value === 'excel'"
                                [class.surface-50]="formGroup.get('origen').value === 'excel'"
                                [class.border-300]="formGroup.get('origen').value !== 'excel'"
                                (click)="formGroup.get('origen').setValue('excel'); onOrigenChange()">
                                <div class="flex align-items-center">
                                    <div class="flex align-items-center justify-content-center surface-100 border-circle w-3rem h-3rem mr-3">
                                        <i class="pi pi-file-excel text-xl text-green-600"></i>
                                    </div>
                                    <div>
                                        <span class="font-bold text-lg">Archivo Excel/CSV</span>
                                        <p class="text-500 m-0 text-sm">Subir archivo con destinatarios</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- DESTINATARIOS - CONTACTOS (si eligió contactos) -->
                <div class="mb-4 p-4 surface-50 border-round" *ngIf="origenSeleccionado === 'contactos'">
                    <div class="flex align-items-center mb-3">
                        <span class="text-900 font-bold">Seleccionar contactos de la lista</span>
                    </div>
                    
                    <!-- Filtro por tipo de tarjeta (solo cooperativas) -->
                    <div class="flex gap-3 mb-3" *ngIf="currentUser.empresa.tipo === tipoCooperativa && moduloTarjeta">
                        <div class="flex-auto">
                            <label class="block text-500 text-sm mb-1">Tipo de tarjeta</label>
                            <p-dropdown [options]="contactosMedalla" formControlName="contactos_medalla" 
                                optionLabel="nombre" optionValue="valor" styleClass="w-full"
                                (onChange)="onTipoTarjetaChange()">
                            </p-dropdown>
                        </div>
                    </div>
                    
                    <!-- Selector de correos -->
                    <div>
                        <label class="block text-500 text-sm mb-1">
                            <i class="pi pi-envelope mr-1"></i>
                            Destinatarios ({{ contactosSeleccionados?.length || 0 }} seleccionados)
                        </label>
                        <p-multiSelect 
                            [options]="contactos" 
                            display="chip" 
                            optionLabel="label" 
                            optionValue="correo"
                            formControlName="contactosSeleccionados" 
                            (onFilter)="onFilter($event)"
                            placeholder="Buscar y seleccionar correos..."
                            [filter]="true"
                            [showClear]="true"
                            styleClass="w-full">
                        </p-multiSelect>
                    </div>
                </div>

                <!-- DESTINATARIOS - EXCEL (si eligió excel) -->
                <div class="mb-4 p-4 surface-50 border-round" *ngIf="origenSeleccionado === 'excel'">
                    <div class="flex align-items-center mb-3">
                        <i class="pi pi-file-excel text-2xl text-green-500 mr-2"></i>
                        <span class="text-900 font-bold">Subir archivo con destinatarios</span>
                    </div>
                    
                    <!-- Instructivo de columnas requeridas -->
                    <div class="mb-3 p-2 surface-100 border-round">
                        <div class="flex align-items-center text-sm text-600">
                            <i class="pi pi-info-circle mr-2"></i>
                            <span>El archivo debe tener las siguientes columnas en la primera fila:</span>
                        </div>
                        <div class="mt-2 flex gap-3 flex-wrap">
                            <span class="p-tag p-tag-success">correo / email / e-mail / mail</span>
                            <span class="p-tag">nombre (opcional)</span>
                            <span class="p-tag">telefono / celular (opcional)</span>
                        </div>
                    </div>
                    
                    <p-fileUpload 
                        mode="advanced"
                        chooseLabel="Seleccionar archivo Excel o CSV"
                        uploadLabel="Subir"
                        cancelLabel="Cancelar"
                        [auto]="false"
                        accept=".xlsx,.xls,.csv"
                        maxFileSize="5000000"
                        (onSelect)="onExcelSelect($event)"
                        (onClear)="onExcelClear()"
                        [showUploadButton]="false"
                        [showCancelButton]="false">
                        <ng-template pTemplate="content">
                            <div *ngIf="!archivoExcelSubido" class="text-center p-4">
                                <i class="pi pi-cloud-upload text-4xl text-400 mb-2"></i>
                                <p class="text-500">Arrastra un archivo o haz clic para seleccionar</p>
                                <p class="text-400 text-sm">Formatos: .xlsx, .xls, .csv (máx 5MB)</p>
                            </div>
                        </ng-template>
                    </p-fileUpload>
                    
                    <!-- Stats del archivo -->
                    <div class="mt-3" *ngIf="archivoExcelSubido">
                        <div class="flex align-items-center justify-content-between p-3 surface-100 border-round">
                            <div class="flex align-items-center">
                                <i class="pi pi-check-circle text-green-500 text-xl mr-2"></i>
                                <span class="font-bold">{{ excelStats.validos }} destinatarios válidos</span>
                            </div>
                            <div class="text-500 text-sm" *ngIf="excelStats.invalidos > 0">
                                <i class="pi pi-exclamation-triangle text-orange-500 mr-1"></i>
                                {{ excelStats.invalidos }} registros omitidos
                            </div>
                        </div>
                    </div>
                    
                    <!-- Preview -->
                    <div class="mt-3" *ngIf="excelPreview.length > 0">
                        <p class="text-500 text-sm mb-2">Vista previa (primeros 5):</p>
                        <p-table [value]="excelPreview" styleClass="p-datatable-sm" [rows]="5">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Correo</th>
                                    <th>Nombre</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-row>
                                <tr>
                                    <td>{{ row.correo || '-' }}</td>
                                    <td>{{ row.nombre || '-' }}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>

                <!-- PÁGINA 2: CONTENIDO DEL CORREO -->
                <div class="mb-4">
                    <div class="flex align-items-center mb-3">
                        <span class="text-900 font-bold text-xl mr-2">2.</span>
                        <span class="text-900 font-bold text-xl">¿Qué quieres enviar?</span>
                    </div>
                    
                    <div class="grid">
                        <div class="col-12 md:col-6">
                            <div class="field">
                                <label class="block text-500 text-sm mb-1">Asunto *</label>
                                <input pInputText formControlName="nombre" placeholder="ej: Recordatorio de pago"
                                    class="w-full"/>
                                <small *ngIf="invalidControl('nombre')" class="text-red-500">El asunto es requerido</small>
                            </div>
                            <div class="field">
                                <label class="block text-500 text-sm mb-1">Mensaje</label>
                                <textarea pInputTextarea formControlName="descripcion" rows="10" 
                                    placeholder="Escribe el contenido del correo..."
                                    class="w-full" [autoResize]="true"></textarea>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6">
                            <div class="field">
                                <label class="block text-500 text-sm mb-1">
                                    <i class="pi pi-image mr-1"></i>Imagen adjunta (opcional)
                                </label>
                                <p-fileUpload 
                                    mode="basic"
                                    chooseLabel="Seleccionar imagen"
                                    [auto]="false"
                                    accept="image/*"
                                    maxFileSize="10000000"
                                    fileLimit="1"
                                    (onSelect)="onSelect($event)"
                                    (onRemove)="onRemove($event)"
                                    [showUploadButton]="false"
                                    [multiple]="false">
                                </p-fileUpload>
                                <div *ngIf="uploadedFiles.length > 0" class="mt-2">
                                    <p-image [src]="selectFiles[0]?.objectURL" 
                                        [preview]="true" 
                                        width="150"
                                        styleClass="border-round">
                                    </p-image>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- PROGRESS BAR (cuando está enviando) -->
                <div class="mb-4 p-4 surface-50 border-round" *ngIf="mostrarProgreso && jobStatus">
                    <div class="flex align-items-center justify-content-between mb-2">
                        <span class="font-bold">
                            <i class="pi pi-spinner mr-2"></i>
                            Enviando correos...
                        </span>
                        <span class="text-500">{{ jobStatus.estado | titlecase }}</span>
                    </div>
                    <p-progressBar [value]="jobStatus.porcentaje" [showValue]="true"></p-progressBar>
                    <div class="flex justify-content-between mt-2 text-sm text-500">
                        <span>{{ jobStatus.procesados }} enviados</span>
                        <span>{{ jobStatus.fallos }} fallidos</span>
                    </div>
                </div>

                <!-- BOTÓN ENVIAR -->
                <div class="flex justify-content-end">
                    <button pButton pRipple type="button" 
                        label="✉️ ENVIAR CORREO" 
                        icon="pi pi-send"
                        class="p-button-lg p-button-success"
                        (click)="enviar()"
                        [disabled]="loading || (origenSeleccionado === 'excel' && !archivoExcelSubido)">
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<app-on-lista [show]="showOnLista" [title]="tituloOnLista" [columns]="columnasOnLista" 
    [service]="serviceOnLista" [recordName]="recordNameOnLista" [filters]="filters"
    (close)="cerrarOnLista($event)">
</app-on-lista>